import React from 'react';
import * as Inovx from '@shared';
import RoleForm from './RoleForm';
import LinkedRoleForm from './LinkedRoleForm';
import RoleStore from '../stores/RoleStore';
import RoleActions from '../actions/RoleActions';
import RoleConstants from '../constants/RoleConstants';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;

declare var InovxLoader: any;

interface RoleProps {
}

interface RoleState {
    settings: IRoleSettings;
    allRoles?: IOrganizationRole[];
    modalVisible?: boolean;
    isActionInProgress?: boolean;
    isLinkedRole?: boolean;
}

function getRoleState(): RoleState {
    return {
        settings: RoleStore.getSettings(),
        allRoles: RoleStore.getAll(),
        modalVisible: RoleStore.getModalVisible(),
        isActionInProgress: SystemStore.isActionInProgress(RoleConstants.ROLE_DELETE),
        isLinkedRole: RoleStore.isLinkedRole(),
    }
}

class Role extends Inovx.Shared.ReactExt.BaseAppComponent<RoleProps, RoleState> {
    constructor(props: RoleProps, context: any) {
        super('role', props, context);

        this.state = getRoleState();
    }

    protected _initialize = () => {
        RoleActions.getAllRoles(() => {
            RoleActions.getSettings(() => {
                this._appLoaded = true;
            }, (error) => {
                this._handlePermissionError(error);
            });
        }, (error) => {
            this._handlePermissionError(error);
        }, true);
    }

    private _addRole = () => {
        RoleActions.beginAdd(false);
    }

    private _addLinkedRole = () => {
        RoleActions.beginAdd(true);
    }

    private _beginEditRole = (e: Event, role: IOrganizationRole) => {
        RoleActions.beginEdit(role);
    }

    private _deleteRole = (e: Event, role: IOrganizationRole) => {
        var messageObject = {
            message: InovxLoader.t('role:message.confirmDelete'),
            confirmCallback: function () {
                RoleActions.deleteRole(role, null);
            }
        };
        SystemActions.displayConfirmationMessage(messageObject);
    }

    private _hideModal = () => {
        RoleActions.finishEdit();
    }

    private _onChange = () => {
        this.setState(getRoleState());
    }

    private _onSystemChange = () => {
        this.setState({ isActionInProgress: SystemStore.isActionInProgress(RoleConstants.ROLE_DELETE) });
    }

    componentWillMount() {
        this.componentWillMountBase();
    }

    componentDidMount() {
        RoleStore.addChangeListener(this._onChange);
        SystemStore.addChangeListener(this._onSystemChange);
    }

    componentWillUnmount() {
        RoleStore.removeChangeListener(this._onChange);
        SystemStore.removeChangeListener(this._onSystemChange);
    }

    public render() {
        var btns: any[] = [];
        btns.push({
            onClick: this._addRole,
            btnUrl: `${UrlUtilities.getBaseApplicationUrl()}/images/addOrganizationRole.png`,
            btnAtt: {
                alt: InovxLoader.t("role:header.newRole"),
                title: InovxLoader.t("role:header.newRole"),
                id: 'roleApp-add-btn'
            }
        });

        if (this.state.settings.IsExternalAuthentication) {
            btns.push({
                onClick: this._addLinkedRole,
                btnUrl: `${UrlUtilities.getBaseApplicationUrl()}/images/addLinkedRole.png`,
                btnAtt: {
                    alt: InovxLoader.t('role:header.newLinkedRole'),
                    title: InovxLoader.t('role:header.newLinkedRole'),
                    id: 'roleApp-addLinkedRole-btn',
                }
            });
        }

        var iconHeaderProps: any = {
            iconUrl: `${UrlUtilities.getBaseApplicationUrl()}/images/OrganizationRoles.png`,
            iconAtt: { alt: InovxLoader.t("role:header.organizationRoles") },
            title: InovxLoader.t("role:header.organizationRoles"),
            rcClass: "cd-btn add-btn",
        };
        iconHeaderProps.btnUrls = btns;

        var columns = [{
            field: "Name",
            headerText: InovxLoader.t("role:common.roleName"),
            type: "string"
        }, {
            field: "Description",
            headerText: InovxLoader.t("role:common.description"),
            type: "string"
        }, {
            field: "Type",
            headerText: InovxLoader.t('role:grid.type'),
            type: "string",
            width: "100px"
        }];

        var dataSource = this.state.allRoles;
        var defaultSort = [{
            field: "Name",
            dir: "ascending"
        }];

        var commands = {
            headerText: InovxLoader.t("role:common.actions"),
            command: [{
                iconClassName: "glyphicon glyphicon-pencil",
                click: this._beginEditRole
            }, {
                iconClassName: "glyphicon glyphicon-trash",
                click: this._deleteRole
            }],
            width: "85px"
        }
        return (
            <Inovx.Shared.Core.ReactLoader appReady={this.isAppLoaded()} errorStatus={this._errorStatus}>
                <div className="role-app-content">
                    <Inovx.Shared.Controls.If condition={this.state.isActionInProgress} class={'temp-modal-loader'}>
                        <div className="action-in-progress-loader-lrg"></div>
                    </Inovx.Shared.Controls.If>

                    <Inovx.Shared.Layout.IconHeader {...iconHeaderProps} />
                    <Inovx.Shared.Controls.Grid dataSource={dataSource} commands={commands} columns={columns} defaultSort={defaultSort}
                        pageable={{ pageCount: 5, pageSizes: [10, 20, 50], pageSize: 10 }} sort={true} filter={true} />
                </div>
                {!this.state.isLinkedRole &&
                    <Inovx.Shared.Controls.ModalSlider isOpen={this.state.modalVisible} onClose={this._hideModal}>
                        <RoleForm />
                    </Inovx.Shared.Controls.ModalSlider>
                }
                {this.state.isLinkedRole &&
                    <Inovx.Shared.Controls.ModalSlider isOpen={this.state.modalVisible} onClose={this._hideModal}>
                        <LinkedRoleForm />
                    </Inovx.Shared.Controls.ModalSlider>
                }
            </Inovx.Shared.Core.ReactLoader>
        );
    }
}

export default Role;
